module.exports = __webpack_public_path__ + "img/10.cbbf1620.png";